import { Link } from 'react-router-dom';

const NEWSLETTER_FORM_URL = 'http://hgok7.com/';

export default function Footer() {
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = (form.querySelector('[name="phone_alt"]') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      alert('感谢订阅！');
      form.reset();
      return;
    }
    try {
      const formData = new FormData(form);
      const res = await fetch(NEWSLETTER_FORM_URL, {
        method: 'POST',
        body: new URLSearchParams(formData as unknown as Record<string, string>),
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });
      if (res.ok) {
        alert('订阅成功！感谢您的关注。');
        form.reset();
      } else {
        alert('订阅失败，请稍后再试。');
      }
    } catch {
      alert('网络错误，请稍后再试。');
    }
  };

  return (
    <footer className="bg-foreground-950 text-background-50 mt-12 mx-4 md:mx-6 rounded-[2rem] overflow-hidden">
      <div className="px-8 md:px-14 py-14 md:py-16">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-0" style={{ width: '100%' }}>
          {/* Left - Subscribe */}
          <div className="lg:w-[2fr] pr-0 lg:pr-16">
            <h3 className="text-3xl md:text-4xl font-heading font-light text-background-50 tracking-tight">
              订阅更新
            </h3>
            <p className="mt-3 text-foreground-300 text-sm leading-relaxed max-w-md">
              订阅我们的邮件，第一时间获取最新漫画更新通知和独家推荐。
            </p>
            <form onSubmit={handleSubmit} className="mt-6 flex flex-col sm:flex-row gap-3 max-w-md">
              <input
                type="email"
                name="email"
                placeholder="请输入您的邮箱"
                className="flex-1 bg-transparent border-b border-foreground-700 px-1 py-2.5 text-sm text-background-50 placeholder:text-foreground-500 outline-none focus:border-primary-500 transition-colors"
                required
              />
              <input
                type="text"
                name="phone_alt"
                className="form-hp-field"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
              />
              <button
                type="submit"
                className="whitespace-nowrap px-6 py-2.5 rounded-full bg-background-50 text-foreground-950 text-sm font-label font-semibold hover:bg-background-100 transition-colors cursor-pointer"
              >
                订阅
                <i className="ri-arrow-right-line ml-1.5"></i>
              </button>
            </form>
          </div>

          {/* Center - Quick Links */}
          <div className="lg:w-[1fr]">
            <h4 className="text-sm font-label font-semibold text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-3">
              <li><Link to="/" className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap">首页</Link></li>
              <li><Link to="/category/romance" className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap">漫画分类</Link></li>
              <li><Link to="/category/action" className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap">排行榜</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap">关于我们</Link></li>
            </ul>
          </div>

          {/* Right - Contact */}
          <div className="lg:w-[1.5fr]">
            <h4 className="text-sm font-label font-semibold text-background-50 mb-4">联系方式</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-2.5 text-sm text-foreground-300">
                <i className="ri-phone-line text-base w-4 h-4 flex items-center justify-center"></i>
                <span>400-888-6666</span>
              </li>
              <li className="flex items-center gap-2.5 text-sm text-foreground-300">
                <i className="ri-mail-line text-base w-4 h-4 flex items-center justify-center"></i>
                <span>hello@hgok7.com</span>
              </li>
            </ul>
            <div className="mt-8">
              <h4 className="text-sm font-label font-semibold text-background-50 mb-4">公司地址</h4>
              <p className="text-sm text-foreground-300 leading-relaxed">
                北京市朝阳区望京SOHO<br />T3栋28层2806室
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-foreground-800/40 px-8 md:px-14 py-5 flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-6">
          <a href="#" className="text-xs text-foreground-400 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">微博</a>
          <a href="#" className="text-xs text-foreground-400 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">小红书</a>
          <a href="#" className="text-xs text-foreground-400 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">B站</a>
        </div>
        <p className="text-xs text-foreground-500 whitespace-nowrap">
          &copy; 2026 动漫之家 版权所有
        </p>
        <div className="flex items-center gap-6">
          <a href="#" className="text-xs text-foreground-400 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">隐私政策</a>
          <a href="#" className="text-xs text-foreground-400 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">服务条款</a>
        </div>
      </div>
    </footer>
  );
}